/*
 * IMPORTS
 */
import React from 'react'
import { Flex, Text, useBreakpointValue } from '@chakra-ui/react'
import HddStats from 'components/HddStats'
import CpuRamChart from 'components/CpuRamChart'
import SystemInfoStats from 'components/SystemInfoStats'
import DatabaseTable from 'components/DatabaseTable'
import DeleteDataManager from 'components/DeleteDataManager'
import SystemInfoSubscriptionProvider from 'components/SystemInfoSubscriptionProvider'


const Index = () => {
  // Const statement.
  const _isCurrentViewMobile = useBreakpointValue({
    base: true,
    sm: true,
    md: false,
    lg: false,
    xl: false
  }, { fallback: 'base' })
  const _isCurrentViewTablet = useBreakpointValue({
    base: false,
    sm: false,
    md: true,
    lg: false,
    xl: false
  }, { fallback: 'base' })

  // Return component.
  return (
    <SystemInfoSubscriptionProvider>
      <Flex
        direction="column"
        fontFamily="DM Sans"
        pb="40px"
      >

        <Text
          textColor="#2B3674"
          fontWeight="bold"
          fontFamily="Poppins"
          fontSize={['clamp(20px, 3vw, 40px)']}
          lineHeight="40px"
          letterSpacing="0.48px"
          py="20px"
          pl="20px"
        >
          Server Status
        </Text>

        {/* CPU Chart, HDD Stats */}
        <Flex
          mt="20px"
          flexDir={_isCurrentViewMobile || _isCurrentViewTablet ? 'column' : 'row'}
          gap="20px"
          bg="#F8F9FA"
          px={_isCurrentViewMobile ? '12px' : '22px'}
        >
          <Flex flex={1} minWidth={0} >
            <CpuRamChart title="DB Server CPU & RAM Usage" />
          </Flex>
          <Flex flex={1} minWidth={0} flexDirection="column" gap="20px">
            <Flex
              flex={0.2}
              minWidth={0}
              gap="10px"
              flexDir="column"
              justifyContent="flex-start"
            >
              <DeleteDataManager title="Data Management" />
              <DatabaseTable title="Delete All data" />

            </Flex>
            <Flex
              flexDir="column"
            >
              <HddStats title="HddStats(DB)" />
            </Flex>
          </Flex>
        </Flex>

        {/*  Traffic Stream, System Info */}
        <Flex
          mt="20px"
          bg="#F8F9FA"
          flexDir={_isCurrentViewMobile || _isCurrentViewTablet ? 'column' : 'row'}
          gap="20px"
          px={_isCurrentViewMobile ? '12px' : '22px'}
        >

          <Flex flex={1} minWidth={0} >
            <SystemInfoStats title="SystemInfoStats" />
          </Flex>

        </Flex>
      </Flex>
    </SystemInfoSubscriptionProvider>
  )
}

export default Index
